import React, { useState } from 'react'
import CloseRoundedIcon from '@mui/icons-material/CloseRounded'
import { Box } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import AdxInfoModal from 'components/reusable/modal/AdxInfoModal'
import AdxButton from 'components/custom/AdxButton'

const ExitPrompModal = () => {
  const navigate = useNavigate()

  const [isModalOpen, setIsModalOpen] = useState(false)
  const handleClose = () => {
    setIsModalOpen(false)
  }

  return (
    <React.Fragment>
      <Box
        onClick={() => setIsModalOpen(true)}
        sx={{
          width: '35px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          ml: '16px',
          cursor: 'pointer',
        }}
        display={'flex'}
        width={'35px'}
        alignItems={'center'}
        justifyContent={'center'}
        ml={'16px'}
      >
        <CloseRoundedIcon />
      </Box>
      <AdxInfoModal
        variant={'error'}
        open={isModalOpen}
        onClose={handleClose}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        title="Do you want to exit this test?"
        subtitle="All answered questions will be discarded"
        muiIcon="error"
        iconColor="error.main"
        footerButtons
        firstBtnLabel={'Confirm'}
        firstBtnHandle={() => navigate('/app/performance/assessment')}
        secondBtnLabel={'Go back'}
        secondBtnHandle={handleClose}
      >
        {/* <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, width: '100%' }}>
          <AdxButton
            variant={'contained'}
            onClick={() => navigate('/app/performance/assessment')}
            sx={{
              width: '100%',
              backgroundColor: 'error.main',
              '&:hover': { backgroundColor: 'error.main' },
            }}
          >
            Confirm
          </AdxButton>
          <AdxButton variant={'ghost'} onClick={handleClose} sx={{ width: '100%' }}>
            Go back
          </AdxButton>
        </Box> */}
      </AdxInfoModal>
    </React.Fragment>
  )
}

export default ExitPrompModal
